import { useSelector } from 'react-redux'

import { selectNotifications } from '../../../accessors/index'
import { ReactComponent as BellIcon } from './bell.svg'
import styles from './NotificationBell.module.scss'

const NotificationBell = () => {
  const notifications = useSelector(selectNotifications)

  const count = Object.values(notifications).reduce(
    (prev, curr) => prev + Object.values(curr).reduce((p, c) => p + c.count, 0),
    0
  )

  return (
    <div className={styles.holder}>
      {count > 0 && <span className={styles.count}>{count}</span>}
      <BellIcon />
    </div>
  )
}

export default NotificationBell
